<template>
  <div class="assignPop"
      v-on-clickaway="hidepop"
  >
      <b-container>
          <search-component  
            :searchAppend="{
                state : true,
                icon  : 'x',
                action: closeAssign
            }"
            @searching="filterdrivers"
            placeholder="Assign delivery"
            searchClass="assignSearch"/>

      </b-container>

        <div 
            :class="[{'assingning' : assignTo}]"
            class="accountList">
            <div class="swiper userList">
                <div class="swiper-wrapper">

                    <template v-for="driver in filtereddrivers">
                        <div 
                            :class="['swiper-slide', {'active' : assignTo && assignTo.id == driver.id}]"
                            @click="assignTo = driver"
                            :key="driver.id" >

                            <template v-if="driver.avatar_url">
                                <div 
                                    :style="`background-image:url(${driver.avatar_url});`"
                                    class="userImage">
                                </div>
                            </template>

                            <template v-else>
                                <div 
                                    class="userImage">

                                    <b-icon icon="person"></b-icon>
                                </div>
                            </template>

                            <div class="userName">
                                {{driver.name}}
                            </div>
                        </div>
                    </template>
                    
                </div>

               
            </div>

            <b-container v-if="assignTo">
                <div class="assignAction">
                    <button 
                        :disabled="processing"
                        @click="assignorder"
                        class="btn btn-primary block">
                        ASSIGN {{assignTo.name}}
                    </button>
                </div>
            </b-container>
        </div>
  </div>
</template>

<script>
// components
import searchComponent from '@/components/searchComponent.vue'

//Directives

import { directive as onClickaway } from 'vue-clickaway';



// plugins
import Swiper from 'swiper';
import axios from 'axios'
import _ from 'lodash'

export default {
    props : {
        order : {
            type : Object,
            default : () => {
                return null
            }
        }
    },
    components: {
      'search-component' : searchComponent
   },
   directives: {
        onClickaway: onClickaway,
    },
    data() {
        return {
            swiperUserList : null,
            assignTo       : null,
            filtereddrivers: [],
            processing     : false
        }
    },
    computed : {
        /**
         * Windows size
         */
        windowsize() {
            return this.$store.state.windowsize
        },
        /**
         * Loggedin user
         */
        user () {
            return this.$store.state.user
        },

        /**
         * Driver list
         */
        drivers() {
            return this.$store.state.employees.filter(em => em.roles.includes('driver'))
        },
        /**
         * Socket / webhook connection
         */
        socketio() {
            return this.$store.state.socketio
        }
    },
    methods : {
        /**
         * Clickaway hide popou
         */
        hidepop(e) {
            console.log('eee', e)

            /**
             * Check paths if contain class with deliverassign
             */
            let bypass = false

            e.path.forEach(p =>{
                if(p && p.classList) {
                    const classses = Array.from(p.classList)

                    if(classses.includes('deliverAssign')) {
                        bypass = true
                    }
                }}
            )

            if(!bypass) {
                this.closeAssign()
            }
        },
        /**
         * Search filter function
         * filter drivers
         * and re-initialize swiper
         */
        filterdrivers : _.debounce(function (text) {
            const searchstring = text.toLowerCase()
            const list = this.drivers.filter(dr => {
                const searchbase = dr.name.toLowerCase()
                return searchbase.match(searchstring)
            })

            this.filtereddrivers = list
            this.initUserlist()
        }, 800),
        /**
         * Assign order to the driver
         */
        async assignorder() {
            this.processing = true
            const params = {
                assign_to : this.assignTo.id
            }
            const url = `/assign_order/${this.order.id}`
            await axios.post(url, params).catch(err => console.log(err))
            this.processing = false

            /** 
             * update status to assign
            */
            // const urlstatus = `/update_order_status/${order.order.id}`
            //     await axios.post(urlstatus, {
            //         status    : 'assign',
            //         updated_by: this.user.id
            //     })
           

            /**
             * Broadcast new order assignment
             */
            if(this.socketio) {
                this.socketio.emit('broadcast', {
                    type  : 'assignorder',
                    userid: this.assignTo.id
                })
            }

            /**
             * Emit new assignedorder
             */
            this.$emit('update', this.order.id)

            this.closeAssign();

        },  
        /**
         * Close popout
         */
        closeAssign() {
            this.$emit('close')
            this.assignTo = null
            this.filterdrivers('')
            this.$emit('update:order', null)
        },
        /**
         * Initializ swiper 
         */
        initUserlist() {
            this.$nextTick(() => {

                /**
                 * don't initiate if desktop
                 */
                if(['lg', 'xl', 'xxl'].includes(this.windowsize.breakpoint)) {
                    return;
                }

                this.swiperUserList = new Swiper(".swiper.userList", {
                    slidesPerView: 'auto',
                    spaceBetween : 0,
                    on           : {
                        slideChangeTransitionStart: function(swiper) {
                        let $wrapperEl = swiper.$wrapperEl;
                        let params     = swiper.params;

                        $wrapperEl.children(('.' + (params.slideClass) + '.' + (params.slideDuplicateClass)))
                        .each(function() {
                            let idx = this.getAttribute('data-swiper-slide-index');
                            this.innerHTML = $wrapperEl.children('.' + params.slideClass + '[data-swiper-slide-index="' + idx + '"]:not(.' + params.slideDuplicateClass + ')').html();
                        });
                    },
                    slideChangeTransitionEnd: function(swiper) {
                        swiper.slideToLoop(swiper.realIndex, 0, false);
                    },
                    }
                });
            });
        }
    },
    /**
     * Run function before component rendered
     */
    async beforeMount() {
        
        // get employees list
        await this.$store.dispatch('getemployees')
        this.filtereddrivers = this.drivers
        this.initUserlist()

    },
    /**
     * Run function after component rendered
     */
    mounted() {
    }
}
</script>

<style lang="scss">
@import '@/scss/partials/_mixins.scss';
@import '@/scss/partials/_colors.scss';

.assignPop {
    position        : fixed;
    bottom          : 0;
    left            : 0;
    right           : 0;
    background-color: white;
    box-shadow      : 0 -1px 5px 2px $lightgrey2;
    padding-top     : 15px;
    

    @include screen-min(lg) {
        right        : 0;
        bottom       : 0;
        left         : auto;
        height       : calc(100vh - 60px);
        box-shadow   : none;
        border-left  : 1px solid lighten($lightgrey3, 5);
        width        : 400px;
    }

    .assignSearch {
        margin-bottom : 30px;
    }

    .accountList {
        padding-top   : 30px;
        padding-bottom: 30px;

        

        &.assingning {
            .userName {
                visibility: hidden;

                @include screen-min(lg) {
                    visibility: visible;
                }
            }
        }
    }
    
    .swiper {
        width       : 100%;
        height      : 100%;
        overflow    : initial;
        padding-left: 15px;
    }

    .swiper-wrapper {
        @include screen-min(lg) {
            flex-direction: column;
            height        : calc(100vh - 290px);
            overflow      : hidden auto;
            padding-left  : 15px;
            padding-right : 15px;

        }
    } 

    .swiper-slide {
        text-align    : center;
        font-size     : 18px;
        background    : #fff;
        cursor        : pointer;
        display       : flex;
        align-items   : center;
        flex-direction: column;
        width         : 150px;

        @include screen-min(lg) {
            flex-direction: row;
            padding-top   : 15px;
            padding-bottom: 15px;
            width         : 100%;
            height        : 80px;
        }

        .userImage {
            width              : 50px;
            height             : 50px;
            border-radius      : 100%;
            background-size    : cover;
            background-position: center;

            @include screen-up(sm) {
                width : 55px;
                height: 55px;
            }


            svg {
                width        : 100%;
                height       : 100%;
                border       : 1px solid $grey;
                color        : $grey;
                border-radius: 100%;
                padding      : 15px;
            }
        }

        .userName {
            @include screen-up(sm) {
                font-size : 15px;
            }

            @include screen-min(lg) {
                padding-left : 20px;
            }
        }

        &.swiper-slide-active, &.active {
            .userImage {
                box-shadow: 0 0 0 8px lighten($lightgrey3, 3);
                padding   : 1px;
            }

            .userName {
                @include screen-min(lg) {
                    color : $primaryColor;
                }
            }
        }
    }

    .swiper-slide img {
        display   : block;
        width     : 100%;
        height    : 100%;
        object-fit: cover;
    }
}
</style>